/**
 * This JavaScript component is to support the implementation of OneTrust (OT) features and has a dependency on _onetrust.scss.
 * As part of OT implementation, we embed a button (given by OT) inside <main id="main-content"> element in _Layout.cshtml. The styling in onetrust.scss will hide the button.
 * The purpose of this JavaScript logic is to hide the OT button, but invoke its click event when triggered by SAC action elements (to open Cookie Preference modal)
 * Since the OT button is located apart from SAC action elements, to stop the browser from scrolling down to the active element (the OT button) after Cookie Preference modal is closed,
 * we append new click-event-handlers to both the Close and Confirm buttons of the modal (these buttons close the modal). The new handler will bring the focus back to the SAC action element.
 * Below is an example of how to script the action element (it can be of any element type as long it has class="ot-preference-trigger"):
 * <a class="ot-preference-trigger" href="javascript:void(0)">[Insert Text]</a>
*/

/* 2022-05-10 Update
 
 - This code is sourced from  sourced from SAC.
 - Additional documentation

   The following is the button OT binds to a function that  displays the preference dialog.
   The binding is done by the onetrust script.
   The code is inserted in the master page template (sheamaster.xml) and hidden with Zurb's hide class.

   <!-- OneTrust Preference button -->
   <button class="ot-sdk-show-settings hide" id="ot-sdk-btn" data-uw-styling-context="true">click here</button>
   <!-- End OneTrust Preference button -->

   In the privacy page, there is a 'click here' link with the ot-preference-trigger class.
   The element is bound to to handle the click event which in turn programmatically clicks the ot-sdk-btn button.

*/
(function () {
    document.addEventListener("DOMContentLoaded", function (event) {
        const targetElementSelector = "#ot-sdk-btn",    //OT button
            decoyElementSelector = ".ot-preference-trigger", //"click here" action element in privacy page
            closeBtnSelector = "#close-pc-btn-handler", //Close button inside Cookie Preference modal
            confirmBtnSelector = ".save-preference-btn-handler.onetrust-close-btn-handler"; //Confirm My Choices button inside Cookie Preference modal

        var targetEl = document.querySelector(targetElementSelector);
        var decoyEl = document.querySelectorAll(decoyElementSelector);

        if (targetEl !== null && decoyEl !== null) {
            // Prevent page from reloading
            targetEl.onclick = function (e) {
                e.preventDefault();
            }

            decoyEl.forEach(function (el) {
                el.onclick = function (e) {
                    var closeBtnEl = document.querySelector(closeBtnSelector);
                    var confirmBtnEl = document.querySelector(confirmBtnSelector);

                    var onAction = function () {
                        el.focus();
                        closeBtnEl.removeEventListener("click", onAction);
                        confirmBtnEl.removeEventListener("click", onAction);
                    }

                    closeBtnEl.addEventListener("click", onAction, { once: true });
                    confirmBtnEl.addEventListener("click", onAction, { once: true });

                    targetEl.click();
                }
            });
        }
    });
})();
